(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_12b8c94"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".animate-icon").forEach(icon => {
    const svg = icon.querySelector("svg");
    const type = icon.getAttribute("data-animate");
    const delay = icon.getAttribute("data-delay") || "0s";
    if (svg && type) {
      svg.classList.add("animate", type);
      svg.style.animationDelay = delay;
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
